import { getResolveContentQueryOptions, queryClient, useGetSpace, useSpaceCheckinMutation } from '@onesource/services';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';
import { SubNavPageContainer } from 'src/components/page-container';
import { PreviewModeBanner } from 'src/features/community-hub/components/preview-mode-banner';
import { ContentRouteProvider } from 'src/features/community-hub/hooks/use-content-route';
import { PreviewModeProvider } from 'src/features/community-hub/hooks/use-preview-mode';

/**
 * Program (top-level space) layout. Path: /programs/{programSlug}
 * Resolves the program slug -> id, records a check-in, and provides the
 * content-route context + preview mode to the program subtree.
 */
export const Route = createFileRoute('/_protected/programs/$programSlug')({
  loader: ({ params }) => queryClient.ensureQueryData(getResolveContentQueryOptions({ program: params.programSlug })),
  component: ProgramRouteWrapper,
});

function ProgramRouteWrapper() {
  const { programSlug } = Route.useParams();
  const resolved = Route.useLoaderData();
  const programId = resolved.program.id;
  const { mutate: checkin } = useSpaceCheckinMutation();
  const { data: space } = useGetSpace(programId);

  useEffect(() => {
    checkin(programId);
  }, [programId]);

  return (
    <ContentRouteProvider value={{ programId, programSlug }}>
      <PreviewModeProvider app={space?.app}>
        <SubNavPageContainer>
          <PreviewModeBanner />
          <Outlet />
        </SubNavPageContainer>
      </PreviewModeProvider>
    </ContentRouteProvider>
  );
}
